<template>
  <div>
    <div v-if="BiddingStatus.display_bid_count.length > 0" />
    <div v-if="!BiddingStatus.has_passed && !BiddingStatus.has_sold">
      <div class="biddingAreaValue">
        <Countdown
          :item_id="item_id"
          :bidding_end_date_epoch="biddingEndDateEpoch"
        />
      </div>
    </div>
    <!-- SOLD STATUS -->
    <transition
      v-else
      name="details-update"
    >
      <div
        :key="soldStatus"
        class="askingContainer"
      >
        <div class="biddingAreaTitle">
          {{ soldStatus }}
        </div>
      </div>
    </transition>
    <div :class="{biddingAreaShiftUp: !BiddingStatus.has_sold && !BiddingStatus.has_passed}">
      <BiddingStatus
        :item_id="item_id"
        :view_type="'item'"
      />
      <div
        v-if="!BiddingStatus.has_sold && !BiddingStatus.has_passed"
        class="biddingAreaSpinnerContainer"
      >
        <div :class="{ bidSpinner: BiddingStatus.pending_bid === true, hidden: BiddingStatus.pending_bid !== true }">
          <div class="loading">
            Loading...
          </div>
        </div>
        <div
          class="biddingAreaContainer"
          :class="{ hidden: BiddingStatus.pending_bid === true }"
        >
          <div v-if="!BiddingStatus.has_sold && !BiddingStatus.has_passed">
            <div v-if="step === 'INITIAL'">
              <div class="biddingAreaButtonContainer">
                <div class="biddingAreaInputAndButtonContainer paddingLargeBottom">
                  <div class="biddingAreaInputContainer">
                    <span>$</span>
                    <label for="inputBidAmount" />
                    <div
                      v-if="authenticated"
                      class="bidTextInputContainer"
                    >
                      <div v-if="BiddingStatus.current_live_lot">
                        <span v-text="bidAmount" />
                        <input
                          id="inputBidAmount"
                          ref="inputBidAmount"
                          v-model.number="bidAmount"
                          autocomplete="off"
                          type="number"
                          class="hidden"
                          placeholder=""
                        >
                      </div>
                      <div v-else>
                        <input
                          id="inputBidAmount"
                          ref="inputBidAmount"
                          v-model.number="bidAmount"
                          onclick="this.setSelectionRange(0, this.value.length)"
                          autocomplete="off"
                          type="number"
                          class="biddingAreaBidInput"
                          placeholder=""
                          required
                          @focus="disableBidUpdate = true"
                          @blur="disableBidUpdate = false"
                        >
                      </div>
                    </div>
                    <div
                      v-else
                      class="bidTextInputContainer"
                      v-text="bidAmount"
                    />
                  </div>
                  <div class="biddingAreaBidButtonContainer">
                    <BidButton
                      ref="childBidButton"
                      :item_id="item_id"
                      :bid-amount="bidAmount"
                      :Card="Card"
                      :assume_customer="assume_customer"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="step === 'REQUIRES_CREDIT_CARD'">
              <div
                v-if="!isTelephoneBid"
                class="biddingAreaBidButtonContainer"
              >
                <BidButton
                  :item_id="item_id"
                  :bid-amount="bidAmount"
                  :show-cancel-button="true"
                  :Card="Card"
                  :assume_customer="assume_customer"
                  @resetForm="resetForm"
                />
              </div>
            </div>
            <div v-else-if="step === 'REQUIRES_BID_AMOUNT'">
              <div class="biddingAreaInputContainer">
                $<input
                  id="inputBidAmount"
                  ref="inputBidAmount"
                  v-model.number="bidAmount"
                  type="number"
                  class="biddingAreaBidInput"
                  :disabled="BiddingStatus.current_live_lot"
                  placeholder=""
                  required
                  @focus="disableBidUpdate = true"
                  @blur="disableBidUpdate = false"
                >
              </div>
              <div class="biddingAreaBidButtonContainer">
                <BidButton
                  :item_id="item_id"
                  :bid-amount="bidAmount"
                  :Card="Card"
                  :assume_customer="assume_customer"
                />
              </div>
            </div>
            <div v-else-if="step === 'REQUIRES_AGREEMENT_TO_TERMS'">
              <div class="biddingAreaAdditionalErrorInfo">
                By clicking "I Agree," you acknowledge that you have read, understand, and agree to the Terms &amp; Conditions for this auction.
                <br><br>
                <span v-if="$store.getters.customerInternational">Please note that <span class="bold">international bidders are required to pay by wire transfer</span> for all winning bids within five (5) days of the close of the auction.</span>
              </div>
              <div
                v-if="!isTelephoneBid"
                class="biddingAreaBidButtonContainer"
              >
                <BidButton
                  :item_id="item_id"
                  :bid-amount="bidAmount"
                  :show-cancel-button="true"
                  :Card="Card"
                  :assume_customer="assume_customer"
                  @resetForm="resetForm"
                />
              </div>
            </div>
            <div v-else-if="step === 'REQUIRES_AMOUNT_CONFIRMATION'">
              <div
                v-if="!isTelephoneBid"
                class="biddingAreaBidButtonContainer paddingLargeBottom"
              >
                <BidButton
                  :item_id="item_id"
                  :bid-amount="bidAmount"
                  :show-cancel-button="true"
                  :Card="Card"
                  :assume_customer="assume_customer"
                  @resetForm="resetForm"
                />
              </div>
              <div
                v-else-if="BiddingStatus.is_telephone_bidding_open"
                class="biddingAreaBidButtonContainer"
              >
                <TelephoneButton
                  :item_id="item_id"
                  :primary-phone="primaryPhoneFormatted"
                  :secondary-phone="secondaryPhoneFormatted"
                  :show-cancel-button="true"
                  :Card="Card"
                />
              </div>
            </div>
            <div v-else-if="step === 'NOT_PROVIDED'">
              <div class="biddingAreaButtonContainer">
                <div>
                  <div class="biddingAreaInputContainer">
                    $<input
                      id="inputBidAmount"
                      ref="inputBidAmount"
                      v-model.number="bidAmount"
                      type="number"
                      class="biddingAreaBidInput"
                      :disabled="BiddingStatus.current_live_lot"
                      placeholder=""
                      required
                      @focus="disableBidUpdate = true"
                      @blur="disableBidUpdate = false"
                    >
                  </div>
                  <div class="biddingAreaBidButtonContainer">
                    <BidButton
                      :item_id="item_id"
                      :bid-amount="bidAmount"
                      :Card="Card"
                      :assume_customer="assume_customer"
                    />
                  </div>
                </div>
                <div v-if="BiddingStatus.is_telephone_bidding_open">
                  <TelephoneButton
                    :item_id="item_id"
                    :primary-phone="primaryPhoneFormatted"
                    :secondary-phone="secondaryPhoneFormatted"
                    :Card="Card"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!BiddingStatus.has_sold && !BiddingStatus.has_passed"
            class="additionalStatusDetailsContainer"
          >
            <div v-if="step === 'INITIAL' && !BiddingStatus.has_sold && !BiddingStatus.has_passed">
              <transition name="details-update">
                <div
                  :key="bidLimit"
                  class="biddingStatus understatedText"
                  v-html="bidLimit"
                />
              </transition>
              <transition name="details-update">
                <div
                  v-if="requiresCreditCardValue"
                  :key="requiresCreditCardValue"
                  class="paddingSmallTop biddingStatus understatedText"
                >
                  A credit card is required to place a bid.  <a
                    href="#"
                    @click="bid"
                  >Add a credit card now</a>.
                </div>
              </transition>
            </div>
            <div v-else-if="step !== 'INITIAL' && !BiddingStatus.has_sold && !BiddingStatus.has_passed">
              <transition name="details-update">
                <div
                  :key="$store.getters.errorMessage.payload.details"
                  class="biddingStatus understatedText"
                  v-html="$store.getters.errorMessage.payload.details"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BiddingMessages
      v-if="!BiddingStatus.has_sold && !BiddingStatus.has_passed"
      :item_id="item_id"
    />
  </div>
</template>

<script>
import BidButton from '@/components/BidButton'
import BiddingStatus from '@/components/BiddingStatus'
import Countdown from '@/components/Countdown'
import BiddingMessages from '@/components/BiddingMessages'

export default {
  name: 'PhoneBiddingArea',
  components: {
    BidButton,
    BiddingStatus,
    BiddingMessages,
    Countdown
  },
  props: [
    'item_id',
    'assume_customer'
  ],
  data () {
    return {
      'soldStatus': '',
      'disableBidUpdate': false,
      'bidAmount': null,
      'isTelephoneBid': false,
      'testPhone': {},
      'primaryPhone': '',
      'primaryPhoneFormatted': '',
      'secondaryPhone': '',
      'secondaryPhoneFormatted': '',
      'Card': {
        'card_number': '',
        'expire_month': '',
        'expire_year': '',
        'cvv2': '',
        'billing_address': '',
        'billing_zip': ''
      }
    }
  },
  computed: {
    authenticated: function () {
      return this.$store.getters.isAuthenticated
    },
    biddingEndDateEpoch: function () {
      if (!this.$store.getters.biddingStatuses['ITEMID_' + this.item_id]) {
        return null
      }
      return (this.$store.getters.biddingStatuses['ITEMID_' + this.item_id].bidding_end_date_epoch)
    },
    /**
     * @return {null}
     */
    CustomerMaxBid: function () {
      if (!this.$store.getters.customerMaxBids[this.item_id]) {
        return {
          'bid_amount': null,
          'next_increment': null
        }
      } else {
        return this.$store.getters.customerMaxBids[this.item_id]
      }
    },
    BiddingStatus: function () {
      if (!this.$store.getters.biddingStatuses['ITEMID_' + this.item_id]) {
        return {
          'current_asking_bid': '',
          'current_high_bid_amount': '',
          'current_high_bid_recognized': '',
          'current_high_bidcard': '',
          'current_live_lot': false,
          'display_bid_count': '',
          'has_passed': false,
          'has_sold': false,
          'is_bidding_open': false,
          'is_telephone_bidding_open': false,
          'clerked_amount': '',
          'pending_bid': false,
          'phone_bid_started': false,
          'seconds_remaining': 0,
          'bidding_end_date': '',
          'bidding_end_date_epoch': '',
          'auction_ignore_bid_limit': '',
          'auction_id': '',
          'bidding_history': {}
        }
      }
      return this.$store.getters.biddingStatuses['ITEMID_' + this.item_id]
    },
    step: function () {
      let self = this
      if (this.$store.getters.errorMessage.payload.adjustedAmount !== undefined) {
        self.bidAmount = this.$store.getters.errorMessage.payload.adjustedAmount
      }
      if (this.$store.getters.errorMessage.active === false) {
        this.resetForm()
        return 'INITIAL'
      } else {
        if (this.$store.getters.apiResponse.messageId === 'REQUIRES_BID_AMOUNT') {
          self.isFloatRight = true
        } else if (this.$store.getters.apiResponse.messageId === 'REQUIRES_CREDIT_CARD') {
          self.isFloatRight = true
        }
        return this.$store.getters.apiResponse.messageId
      }
    },
    bidLimitValue: function () {
      return this.$store.getters.customerBidLimit
    },
    requiresCreditCardValue: function () {
      return this.$store.getters.customerRequiresCreditCard
    },
    bidLimit: function () {
      if (this.bidLimitValue > 0 && !this.BiddingStatus.auction_ignore_bid_limit) {
        return '<span>The current bid limit for this account is $' + this.formatCurrency(this.bidLimitValue) + '.  Learn more about <a href="/bid_limits.html">raising bid limits</a>.</span>'
      }
    }
  },
  watch: {
    'CustomerMaxBid.next_increment': function () {
      this.setBidAmount()
    },
    'BiddingStatus.current_asking_bid': function () {
      this.setBidAmount()
    },
    'BiddingStatus.clerked_amount': function () {
      this.computeSoldStatus()
    },
    'BiddingStatus.phone_bid_started': function () {
      this.computePhoneBidStarted()
    },
    BiddingStatus: function () {
      this.computeSoldStatus()
    }
  },
  methods: {
    setBidAmount: function () {
      if (this.step === 'INITIAL') {
        if (this.CustomerMaxBid.next_increment && this.BiddingStatus.current_asking_bid) {
          if (this.CustomerMaxBid.next_increment > this.BiddingStatus.current_asking_bid) {
            return this.CustomerMaxBid.next_increment
          } else {
            return this.BiddingStatus.current_asking_bid
          }
        } else if (!this.CustomerMaxBid.next_increment && this.BiddingStatus.current_asking_bid) {
          return this.BiddingStatus.current_asking_bid
        } else if (this.CustomerMaxBid.next_increment && !this.BiddingStatus.current_asking_bid) {
          return this.CustomerMaxBid.next_increment
        }
      }
    },
    bid: function () {
      this.$refs.childBidButton.bid()
    },
    formatCurrency: function (amount) {
      return (amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,')
    },
    computePhoneBidStarted: function () {
      if (!this.$store.getters.biddingStatuses['ITEMID_' + this.item_id]) {
        this.isTelephoneBid = false
      } else {
        this.isTelephoneBid = this.$store.getters.biddingStatuses['ITEMID_' + this.item_id].phone_bid_started
      }
    },
    resetForm: function () {
      if (this.disableBidUpdate !== true) {
        this.bidAmount = Math.max(this.CustomerMaxBid.next_increment, this.BiddingStatus.current_asking_bid, this.bidAmount)
      }
    },
    computeSoldStatus: function () {
      if (this.BiddingStatus.has_passed === true) {
        this.soldStatus = 'This lot has passed.'
      } else if (this.BiddingStatus.has_sold === true) {
        this.soldStatus = 'This lot has sold for $' + this.formatCurrency(this.BiddingStatus.clerked_amount)
      } else {
        this.soldStatus = ''
      }
    },
    setCard: function (cardValues) {
      this.Card.card_number = cardValues.card_number
    }
  }
}
</script>

<style scoped>
</style>
